<template>
  <div id="page_app">
    <v-dialog v-model="dialog" persistent width="700">
      <v-card>
        <v-toolbar color="primary" dark  dense cad>
          <v-toolbar-title class="subheading">{{title}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="text-xs-left">
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-container>
              <v-layout fluid row wrap>
                <v-flex lg6 sm12 xs12 pa-20>
                  <v-text-field
                    class="padr"
                    :rules="Rules"
                    required
                    label="Label"
                    name="label"
                    v-model="addnews.label"
                  ></v-text-field>
                </v-flex>
                <v-flex lg6 sm12 xs12>
                  <v-select
                    label="Jenis Menu"
                    item-text="text"
                    item-value="value"
                    v-model="addnews.type"
                    :items="jenismenu"
                  ></v-select>
                </v-flex>
                <v-flex lg6 sm12 xs12>
                  <v-text-field
                    class="padr"
                    label="ID Operator"
                    name="category"
                    v-model="addnews.idoperator"
                  ></v-text-field>
                </v-flex>
                <v-flex lg6 sm12 xs12>
                  <v-text-field
                    label="Kode Produk (PPOB Single produk)"
                    name="kodeproduk"
                    v-model="addnews.kodeproduk"
                  ></v-text-field>
                </v-flex>
                <v-flex lg6 sm12 xs12>
                  <v-select
                    label="Show Home"
                    item-text="text"
                    item-value="showhome"
                    v-model="addnews.showhome"
                    :items="showhomes"
                  ></v-select>
                </v-flex>
                <v-flex lg6 sm12 xs12>
                  <v-text-field label="Target URL (untuk webview)" name="url" v-model="addnews.url"></v-text-field>
                </v-flex>
                <v-flex lg6 sm12 xs12>
                  <v-text-field label="Deskripsi ( Optional )" name="description" v-model="addnews.description"></v-text-field>
                </v-flex>
                <v-flex lg6 sm12 xs12>
                  <v-select
                    label="Status"
                    item-text="text"
                    item-value="status"
                    v-model="addnews.status"
                    :items="statuses"
                  ></v-select>
                </v-flex>
                <v-flex lg2 sm2 xs2>
                  <v-text-field
                    type="number"
                    label="Sort Order"
                    name="order"
                    v-model="addnews.order"
                  ></v-text-field>
                </v-flex>
                <v-flex lg12 sm12 xs12>
                  <input
                    hidden
                    name="imageupload"
                    type="file"
                    accept="image/*"
                    ref="imageupload"
                    v-on:change="upload($event.target.files)"
                  />
                </v-flex>
                <v-flex lg12 sm12 xs12>
                      <img
                              id="imgbanner"
                              class="imgupload"
                              src="https://placehold.co/200x200"
                              alt="image"
                              @click="openfile()"
                              width="100"
                              height="100"
                      />
                  <v-progress-circular
                          :size="70"
                          :width="2"
                          v-if="loadingupload"
                          color="red"
                          indeterminate
                  ></v-progress-circular>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="closeform()">Cancel</v-btn>
          <v-btn
            :disabled="!valid || loadingupload"
            :loading="loading || loadingupload"
            color="success"
            @click="simpanForm(addnews)"
          >Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <div class="mt-4 pr-2 pl-2 pt-2 border_all" style="border: thin solid rgba(0,0,0,.12)" elevation="0">
            <v-toolbar elevation="0">
              <v-text-field
                flat
                solo
                prepend-icon="search"
                placeholder="Type something"
                v-model="search"
                hide-details
                class="hidden-sm-and-down"
              ></v-text-field>
              <v-spacer/>
              <v-btn color="success" @click.native="openmodal()">
                <v-icon dark>add</v-icon>Add
              </v-btn>
              <v-btn class="ml-2" color="primary" @click.native="getNews(opsi)">
                <v-icon dark>refresh</v-icon>Refresh
              </v-btn>
            </v-toolbar>

            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :search="search"
                :items="list"
                class="elevation-0"
                item-key="id"
                :loading="loading"

                :options.sync="opsi"
                :server-items-length="totaldata"
                v-model="complex.selected"
              >
                <template v-slot:progress>
                  <v-skeleton-loader
                          v-if="loading"
                          transition="fade-transition"
                          type="table-tbody">
                  </v-skeleton-loader>
                </template>

                <template v-slot:item.image="{ item }">
                  <div class="ma-4">
                    <v-img :src="item.image" contain
                           aspect-ratio="1.5" class="pa-5">
                    </v-img>
                  </div>
                </template>
                <template v-slot:item.action="{ item }">
                  <div class="ma-4 text-xs-left">
                    <v-btn @click.native="openFormEdit(item)" icon small>
                      <v-icon color="primary" small>edit</v-icon>
                    </v-btn>
                    <v-btn @click.native="deleteItem(item)" icon small>
                      <v-icon color="pink">delete</v-icon>
                    </v-btn>
                  </div>
                </template>


                <template v-slot:item.type="{ item }">
                  <div class="ma-4 text-xs-left">
                    {{ jenismenuToText(item.type) }}
                  </div>
                </template>
                <template v-slot:item.status="{ item }">
                  <div class="ma-4 text-xs-left">
                    <v-chip
                      v-if="item.status===1"
                      color="green"
                      small
                      text-color="white"
                    >{{ statusformat(item.status) }}</v-chip>
                    <v-chip
                      v-else
                      color="red"
                      small
                      text-color="white"
                    >{{ statusformat(item.status) }}</v-chip>
                  </div>
                </template>
              </v-data-table>
            </v-card-text>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  components: {

  },
  data: () => ({
    state_add: false,
    search: '',
    title:"Edit Menu",
    defaultSelected_status: {
      value: '1',
      text: 'Enable'
    },
    jenismenu: [
      { value: 1, text: 'PPOB  Single Produk' },
      { value: 2, text: 'Category' },
      { value: 12, text: 'Category Filter Nomor' },
      { value: 3, text: 'PPOB  Multi Produk' },
      { value: 4, text: 'Web View' },
      { value: 5, text: 'Pembelian' },
      { value: 6, text: 'Voucher Fisik' },
      { value: 9, text: 'Pulsa & Internet' },
      { value: 15, text: 'Topup Bulk' },
      { value: 16, text: 'Voucher Fisik Bulk' },
      { value: 17, text: 'PPOB Bulk' },
      { value: 18, text: 'Voucher Zero' },
      { value: 19, text: 'Digipos' },
      { value: 20, text: 'Isimple' },
      { value: 21, text: 'Sidompul' },
      { value: 22, text: 'Free Denom' }
      // { value: 11, text: "ECommerce" }
    ],
    showhomes: [
      {
        showhome: 1,
        text: 'YES'
      },
      {
        showhome: 0,
        text: 'NO'
      }
    ],
    statuses: [
      {
        status: 1,
        text: 'Enable'
      },
      {
        status: 0,
        text: 'Disable'
      }
    ],
    selected_combo: '',
    Rules: [v => !!v || 'Please fill value'],
    applist: [{ text: 'App pulsa', value: 1 }, { text: 'ecommerce', value: 2 }],
    editorOption: {},
    valid: false,
    complex: {
      selected: [],
      headers: [
        {
          text: 'Icon',
          value: 'image'
        },
        {
          text: 'Label',
          value: 'label'
        },
        {
          text: 'Product',
          value: 'kodeproduk'
        },
        {
          text: 'Category',
          value: 'idoperator'
        },
        {
          text: 'Target URL',
          value: 'url'
        },
        {
          text: 'Description',
          value: 'description'
        },
        {
          text: 'Type',
          value: 'type'
        },
        {
          text: 'Status',
          value: 'status'
        },
        {
          text: 'Sort Order',
          value: 'order',
        },
        {
          text: 'Action',
          value: 'action',
          sortable: false
        }
      ],
      items: []
    },
    delete_id: '',
    editmenu:{},
    addnews: {
      appid: '',
      label: '',
      image: '',
      type: '1',
      description: '',
      kodeproduk: '',
      idoperator: '',
      showhome: 1,
      url: '',
      status: 1,
      order: 1
    },
    opsi: {
      search:'',
      itemsPerPage: 10,
      page:1,
      sortBy: ["id"],
    },
  }),
  created () {
  },
  mounted () {
    this.getNews(this.opsi)
    this.resetimage()
  },
  watch: {
    opsi: {
      handler () {
        this.getNews(this.opsi)
      },
      deep: true
    },
  },
  computed: {
    ...mapState('Appmenu', ['list', 'dialog', 'loading','totaldata','totalpage','options']),
    ...mapState('UploadImage', ['defaultimg','loadingupload'])
  },
  methods: {
    ...mapActions({
      logout: 'account/logout',
      AddNew: 'Appmenu/Add',
      EditMenu: 'Appmenu/Edit',
      closeDialog: 'Appmenu/closeDialog',
      OpenDialogForm: 'Appmenu/OpenDialogForm',
      getNews: 'Appmenu/list',
      delete_news: 'Appmenu/Delete',
      uploadImage: 'UploadImage/uploadImage',
      resetimage:'UploadImage/resetimage'
    }),
    closeform () {
      this.addnews.label = ''
      this.addnews.type = 1
      this.addnews.image = ''
      this.addnews.kodeproduk = ''
      this.addnews.idoperator = ''
      this.addnews.description = ''
      this.addnews.url = ''
      this.addnews.status = 1
      this.addnews.order = 1
      this.addnews.showhome = 1
      this.closeDialog()
      this.state_add = false
      this.getNews(this.opsi)
    },
    async openFormEdit (data) {
      this.title="Edit menu"
      this.addnews = data
      console.log(data);
      this.state_add = false
      await this.OpenDialogForm()
      document.getElementById('imgbanner').src = this.addnews.image

    },
    async openmodal () {

      this.title="Tambah menu"
      this.state_add = true
      this.addnews={
        showhome:1,
        status:1,
        order:1,
        kodeproduk:"",
        description:"",
        url: "",
        idoperator: ""
      };
      await this.OpenDialogForm()
      document.getElementById('imgbanner').src ="https://placehold.co/200x200"

    },
    async simpanForm (data) {
      if (this.state_add) {
        data.image=this.defaultimg
        await this.AddNew(data)
      } else {
        if(this.defaultimg.length>0){
          data.image=this.defaultimg
        }
        await this.EditMenu(data)
      }
    },
    deleteItem (data) {
      this.delete_id = data.id
      if (confirm('Are you sure you want delete ?')) {
        this.delete_news(this.delete_id)
        this.getNews(this.opsi)
      }
    },
    upload: function (files) {
      this.addnews.image = files[0]
      this.showPreview(files[0])
    },
    showPreview: function (file) {
      var reader = new FileReader()
      if(file){
        this.uploadImage(file);
      }
      reader.onload = function (e) {
        document.getElementById('imgbanner').src = e.target.result
      }
      reader.readAsDataURL(file)
    },
    openfile () {
      document.getElementsByName('imageupload')[0].click()
      // this.$refs.imageupload.click();
    },
    statusformat (value) {
      let a = 'Disable'
      if (value === 1) {
        a = 'Enable'
      }
      return a
    },
    jenismenuToText (aMenu) {
      switch (aMenu) {
        case 1:
          return 'PPOB  Single Produk'
        case 2:
          return 'Category'
        case 3:
          return 'PPOB  Multi Produk'
        case 4:
          return 'Web View'
        case 9:
          return 'Pulsa & Internet'
        case 10:
          return 'Pricelist'
        case 11:
          return 'Ecommerce'
        case 15:
          return 'Topup Bulk'
        case 16:
          return 'Voucher Visik Bulk'
        case 17:
          return 'PPOB Bulk'
        default:
          return aMenu
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  .irma-image-priview {
    position: relative;
    margin: 0 auto;
    width: 100%;
    max-width: 150px;
    border-radius: 50%;
    -webkit-box-shadow: 0 0 4px #ccc;
    box-shadow: 0 0 4px #ccc;
  }
  .imgupload-mask {
    width: 100%;
    max-width: 180px;
    height: 100%;
    border-radius: 50%;
    overflow: hidden;
  }
  .iconupload {
    position: absolute;
    top: 0;
  }
.quill {
  height: 300px;
  padding-bottom: 95px;
}

.imgslidelist {
  width: 32px;
  height: 32px;
}

.tdlist {
  padding: 4px !important;
}

.padr {
  padding-right: 10px !important;
}

.tdr {
  padding-left: 30px !important;
}
</style>
